import { Constant } from '../../constant';
import { ViewChild, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PuntoCliente } from 'src/app/models/punto-cliente.model';

declare var google: any;

@Injectable()
export class MapaToolsComponent {

  agm;
  map;
  mapCenter = {
    lat: -25.271707,
    long: -57.593533
  };
  mapConfig;
  markers = [];
  allMarkers = [];
  allGeocercas = [];

  //Para agregar nuevos puntos de cliente
  iconServer = [];
  puntosCliente = [];
  allPuntosCliente = [];

  constant : Constant;
  showTabs: boolean = false;

  mapTypeControlOptions;

  tipoMapa = {
    recorrido: false,
    verflota: true,
  };

  //Muestra las líneas de tráfico
  trafficLayer;
  trafficLayerObs;

  //Al actualizar los puntos se posiciona la cámara en los marcadores de la mitad 100/2
  centerMapMakerUpdate: boolean = true;

  //https://snazzymaps.com/style/61/blue-essence
  initMap() {
    this.mapConfig = this.constant.mapConfig();
  }

  //Instancia de GoogleMap - Corre cuando carga la libería del Mapa
  setInstance(map) {
    this.map = map;
    this.mapTypeControlOptions = {
      position: google.maps.ControlPosition.TOP_RIGHT
    };
    this.trafficLayer = new google.maps.TrafficLayer();
    //this.agm._mapsWrapper.controls = google.maps.ControlPosition.TOP_CENTER;
  }

  /**
   * Actualiza los markers visibles en el view
   */
  updateMarkers() {
    if (this.tipoMapa && this.tipoMapa.verflota) {
      this.markers = this.allMarkers;
      if (this.centerMapMakerUpdate){
        this.disableCenterMapMakerUpdate();
      }
      return;
    }

    if(!this.agm){
      this.markers = this.allMarkers;
      return;
    }
    this.agm._mapsWrapper.getBounds().then(newBounds => {
      this.markers = this.allMarkers.filter((marker) => {
        if (newBounds && marker.visible !== false){
          return newBounds.contains(new google.maps.LatLng(marker.latitud, marker.longitud));
        }
        return false;
      });
      if (this.centerMapMakerUpdate){
        this.disableCenterMapMakerUpdate();
      }
    });
  }

  /**
   * Actualiza los puntos de cliente visibles en el view
   */
  updatePuntosClienteMarkers() {
    if(!this.agm){
      this.puntosCliente = this.allPuntosCliente;
    }
    this.agm._mapsWrapper.getBounds().then(newBounds => {
      this.puntosCliente = this.allPuntosCliente.filter((marker) => {
        if (newBounds){
          return newBounds.contains(new google.maps.LatLng(marker.latitud, marker.longitud));
        }
      });
    });
  }

  /**
   * Desactiva que al actualizar los marcadores se enfoque en los marcadores de la mitad del array ( 100/2 )
   */
  disableCenterMapMakerUpdate() {
    this.centerMapMakerUpdate = false;
  }

  /**
   * Centra el mapa en base a los marcados
   * @param one Posición del Id para centrar el mapa en el marker
   */
  mapCenterMarker(one='') {
    // Validar que existan marcadores
    if (!this.allMarkers || this.allMarkers.length === 0) {
      console.warn('⚠️ No hay marcadores disponibles para centrar el mapa');
      return;
    }

    let centerMarker = (one == '') ? this.allMarkers[Math.floor(this.allMarkers.length / 2)] : this.allMarkers[one];

    // Validar que el marcador exista y tenga coordenadas
    if (!centerMarker || !centerMarker.latitud || !centerMarker.longitud) {
      console.warn('⚠️ Marcador inválido o sin coordenadas', centerMarker);
      return;
    }

    this.centerMap({ latitud: centerMarker.latitud, longitud: centerMarker.longitud })
  }

  /**
   * Centra el mapa en base a coordenadas / zoom
   * @param obj Objeto con los datos de la nueva posición / zoom (opcional)
   * @example { latitud:"-25.472270", longitud:"-57.514120", zoom:19 }
   */
  centerMap(obj) {
    //this.mapCenter.lat = parseFloat(obj.latitud);
    //this.mapCenter.long = parseFloat(obj.longitud);
    if (obj.zoom) { this.setZoom(obj.zoom); }
    this.agm._mapsWrapper.setCenter(new google.maps.LatLng(obj.latitud, obj.longitud));
  }

  /**
   * Cambia el estado visible de los marcadores
   * @param state
   * @param marker
   * @example displayMarker(true)
   */
  displayMarker(state){
    if (state.cod_equipo_rastreo){
      this.allMarkers.forEach((el, i) => {
        if (el.cod_equipo_rastreo == state.cod_equipo_rastreo){
          this.allMarkers[i].visible = state.marker;
        }
      });
    } else {
      this.allMarkers.forEach((el,i) => {
        this.allMarkers[i].visible = state.marker;
      });
    }
  }

  /**
   * Cambia el estado visible de los marcadores
   * @param state
   * @param geocerca
   * @example displayGeocerca(true)
   */
  displayGeocerca(state){
    if (state.cod_geocerca){
      this.allGeocercas.forEach((el, i) => {
        if (el.cod_geocerca == state.cod_geocerca){
          this.allGeocercas[i].visible = state.geocerca;
        }
      });
    } else {
      this.allGeocercas.forEach((el,i) => {
        this.allGeocercas[i].visible = state.geocerca;
      });
    }
  }

  setZoom(zoom){
    if (!zoom) { zoom = 10; }
    this.mapConfig.zoom = zoom;
  }

  setMarkerLabel(label){
    return {
      color: '#ffffff',
      fontWeight: 'normal',
      fontSize: '14px',
      class: 'prueba',
      text: label
    }
  }

  gotToMarker(markerId){
    this.mapCenterMarker(markerId);
  }

  onPolyClick(){

  }

}

